import React from 'react';
import GradientOutlineButton from '../../../components/atoms/GradientOutlineButton';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const WhatToExpectFromAppointment = () => {
  return (
    <div className="w-full flex flex-col justify-between gap-4 sm:gap-6 max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10">
      <h2 className="text-[38px] sm:text-[40px] md:text-[54px] text-primary font-bold leading-[40px] sm:leading-[50px]">
        What to expect <br />
        prior to your appointment?
      </h2>
      <div className="flex flex-col md:flex-row gap-4 sm:gap-10 xl:gap-32">
        <div className="flex-1 flex flex-col items-start gap-4 sm:gap-6">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1, ease: 'easeOut' }}
            viewport={{ once: true, amount: 0.5 }}
          >
            <h4 className="text-pink font-medium italic text-xl 2xl:text-2xl tracking-wide">
              "Bringing Guidepost services into our lives has been absolutely
              incredible." - S.W.
            </h4>
          </motion.div>
          <p className="text-secondary text-lg 2xl:text-2xl">
            Are you worried about your child’s development? We welcome you to
            visit our&nbsp;
            <Link
              to="/services"
              className="font-semibold text-primary hover:underline"
            >
              Therapeutic Services page
            </Link>
            &nbsp; to learn more about what services we offer and how they might
            benefit your child. If you are interested in seeking therapeutic
            services, please call us at&nbsp;
            <span className="font-semibold">(907) 376-4880.</span> Our friendly
            receptionist will assist in answering any questions you may have and
            get your child scheduled for an in-person or telehealth evaluation.
          </p>
          <p className="text-secondary text-lg 2xl:text-2xl">
            Your child may require a referral from their pediatrician for
            insurance coverage. If you already have a therapy referral, please
            request that the physician’s office send to our clinic, “Guidepost
            Pediatric Therapies and Educational Services”, via fax number&nbsp;
            <span className="font-semibold">(907) 376-4885.</span>&nbsp;If you
            do not already have a therapy referral, let our receptionist know
            and we will do our best to assist you in this process.
          </p>
        </div>
        <div className="flex-1 flex flex-col items-start gap-4 sm:gap-6">
          <div className="flex-1 flex flex-col gap-2 w-full max-w-[444px] mt-10">
            <h2 className="text-[28px] sm:text-[34px] text-primary font-bold">
              Prior to your first appointment...
            </h2>
            <p className="text-secondary text-lg 2xl:text-2xl">
              Prior to your first appointment, we will send you intake paperwork
              via “DocuSign”. This paperwork will include questions about your
              child’s demographic information, past development, medical
              history, and consent for treatment. Please complete all intake
              paperwork prior to your first appointment. If you have difficulty
              with the online paperwork, you may complete the paperwork in our
              office. If completing intake paperwork in our office, please
              arrive 15-30 minutes early, as time for completing intake
              paperwork is not built into scheduled evaluation time.
            </p>
            <div className="flex gap-3 mt-6">
              <GradientOutlineButton
                isDark={false}
                text="Therapeutic Services"
                navigateTo={'/services'}
              />
              <GradientOutlineButton
                isDark={false}
                text="Forms"
                navigateTo={'/resources/forms'}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatToExpectFromAppointment;
